import { render, staticRenderFns } from "./hqglZcJIaofuregMain.vue?vue&type=template&id=163fc345&scoped=true&"
import script from "./hqglZcJIaofuregMain.vue?vue&type=script&lang=js&"
export * from "./hqglZcJIaofuregMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163fc345",
  null
  
)

export default component.exports